export default __webpack_public_path__ + "static/media/final-step-vector.ebf7112b.svg";